<template>
  <div class="media-layout">
    <div class="media-layout__top">
      <p v-if="!!title">
        {{ title }}
      </p>
    </div>

    <div class="media-layout__main">
      <slot />
    </div>

    <div class="media-layout__bottom">
      <button
        class="attest-button attest-button--outlined media-layout__continue-button"
        :disabled="!canContinue"
        data-test-id="MediaLayout_ContinueButton"
        @click="$emit('continue')"
      >
        <slot name="button" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: undefined,
    },
    canContinue: {
      type: Boolean,
      required: true,
    },
  },
  emits: {
    continue: () => true,
  },
})
</script>

<style lang="postcss">
.media-layout {
  width: 100%;
  height: 100%;
  background-color: #18283a;
  color: white;
  padding: 5rem 0;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas: 'top' 'main' 'bottom';
  justify-items: center;
  direction: initial;

  &__top {
    grid-area: top;
  }

  &__main {
    grid-area: main;
    align-self: center;
    width: 100%;
  }

  &__bottom {
    grid-area: bottom;
    align-self: end;
  }

  &__continue-button {
    max-width: 18rem;
  }
}
</style>
